<script setup>
import { ref, computed, shallowRef } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useSessionStore } from '@stores';

const sessionStore = useSessionStore();

const { selectedSession, sessionsList, sessionsForSelect } = storeToRefs(sessionStore);
const selectedSessionID = shallowRef(selectedSession.value);

const home = ref({
    icon: 'pi pi-home',
    route: '/',
});

const route = useRoute();
const breadCrumbs = computed(() => {
    if (typeof route.meta.breadCrumb === 'function') {
        return route.meta.breadCrumb.call(null, route);
    }
    return route.meta.breadCrumb;
});
</script>

<template>
    <div class="flex justify-start mb-4 bg-white items-center rounded-xl pr-2">
        <Breadcrumb :home="home" :model="breadCrumbs" class="w-full rounded-xl h-[50px] flex items-center">
            <template #item="{ item, props }">
                <router-link v-if="item.route" v-slot="{ href, navigate, isExactActive }" :to="item.route" custom>
                    <a :href="href" v-bind="props.action" @click="navigate" :class="{ 'router-link-exact-active': isExactActive }">
                        <span :class="[item.icon, 'text-color']" />
                        <span class="route-name">{{ item.label }}</span>
                    </a>
                </router-link>
                <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-surface-700 dark:text-surface-0">{{ item.label }}</span>
                </a>
            </template>
        </Breadcrumb>

        <Select v-if="sessionsList && route.fullPath === '/'" name="sessionsList" v-model="selectedSessionID" filter :options="sessionsForSelect" optionLabel="name" optionValue="id" :placeholder="selectedSession?.name" class="w-96" checkmark @update:modelValue="sessionStore.changeSession" />
    </div>
</template>

<style scoped>
a {
    @apply text-[14px] text-[--text-gray] dark:text-[#FFFFFF40];
}

a.router-link-exact-active {
    @apply text-[--main-black] dark:text-[--main-white];
}

@media (max-width: 768px) {
    .route-name {
        @apply truncate overflow-hidden text-ellipsis;
    }
}

@media (max-width: 1024px) {
}
</style>
